<template>
  <div class="wa--data-forwarding">
    <h1 class="wind--title">
      数据转发
    </h1>
    <hr class="wind--divider wind--divider--subtle" />
    <cv-text-input
      label="风场ID"
      v-model="farmId">
    </cv-text-input>
    <cv-text-input
      label="腾讯风场 batch_id"
      v-model="tencentId">
    </cv-text-input>
    <cv-button
      kind="primary"
      @click="createForwarding">
      创建转发
    </cv-button>
    <hr class="wind--divider wind--divider--subtle" />
    <cv-structured-list v-if="forwarding.length > 0">
      <template v-slot:headings>
        <cv-structured-list-heading>
          风场ID
        </cv-structured-list-heading>
        <cv-structured-list-heading>
          腾讯风场 batch_id
        </cv-structured-list-heading>
        <cv-structured-list-heading>
          操作
        </cv-structured-list-heading>
      </template>
      <template v-slot:items>
        <cv-structured-list-item
          v-for="(map, index) in forwarding"
          :key="index">
          <cv-structured-list-data>
            {{ map.fid }}
          </cv-structured-list-data>
          <cv-structured-list-data>
            {{ map.batch_id }}
          </cv-structured-list-data>
          <cv-structured-list-data>
            <cv-link @click="deleteForwarding(map.fid)">
              删除转发
            </cv-link>
          </cv-structured-list-data>
        </cv-structured-list-item>
      </template>
    </cv-structured-list>
  </div>
</template>
<script>
import {
  CvTextInput,
  CvButton,
  CvStructuredList,
  CvStructuredListHeading,
  CvStructuredListItem,
  CvStructuredListData,
  CvLink
} from '@carbon/vue/src/index'
export default {
  name: 'DataForwarding',
  components: {
    CvTextInput,
    CvButton,
    CvStructuredList,
    CvStructuredListHeading,
    CvStructuredListItem,
    CvStructuredListData,
    CvLink
  },
  data: () => ({
    farmId: '',
    tencentId: '',
    forwarding: []
  }),
  created (){
    this.fetchForwarding()
  },
  methods: {
    fetchForwarding (){
      this.$api.data.forwarding().then( r => {
        if (r.ok) {
          this.forwarding = r.data.forwarding
        } else {
          this.$store.dispatch('ui/toast-notification/show', {
            title: '读取数据转发出错',
            subTitle: r.error.status,
            caption: r.error.description,
            kind: 'warning'
          })
        }
      })
    },
    createForwarding (){
      this.$api.data.createForwarding(this.farmId, this.tencentId).then( r => {
        if (r.ok) {
          this.$store.dispatch('ui/toast-notification/show', {
            title: '创建转发成功',
            kind: 'success'
          })
          this.fetchForwarding()
        } else {
          this.$store.dispatch('ui/toast-notification/show', {
            title: '创建转发失败',
            kind: 'warning'
          })
        }
      })
    },
    deleteForwarding (fid){
      this.$api.data.deleteForwarding(fid).then( r => {
        if (r.ok) {
          this.fetchForwarding()
          this.$store.dispatch('ui/toast-notification/show', {
            title: '删除转发成功',
            kind: 'success'
          })
        } else {
          this.$store.dispatch('ui/toast-notification/show', {
            title: '删除转发出错',
            kind: 'warning',
            subTitle: r.error.status,
            caption: r.error.description
          })
        }
      })
    }
  }
}
</script>